module Meevo.Plugins.Register {
    "use strict";

    export class RefundReasonSection extends Meevo.Plugins.Register.RegisterSectionBase {
    
        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.RefundReason, registerContext, "refundReason", Register.RegisterSectionCatTypeEnum.Sale);
        }

        reset() {
        }
    }

}